import styled from 'styled-components';

import { getSpacing, fontWeight, fontSize } from 'stylesheetB2b';

export const SongInfos = styled.div`
  min-width: 100%;
  white-space: nowrap;
  position: relative;
  margin-bottom: ${getSpacing(2)};
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${fontSize.small};
`;
SongInfos.displayName = 'SongInfos';

export const Title = styled.span`
  font-weight: ${fontWeight.bolder};
`;
Title.displayName = 'Title';
